export const formatToTitleCase = (text: string) => {
  // First convert entire string to lowercase
  const lowerCaseText = text.toLowerCase();
  
  // Then capitalize first letter of each word
  return lowerCaseText.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.slice(1)
  );
};